export class DeviceInfoCollector {

    async getIP(): Promise<string> {
        const response = await fetch('https://api.ipify.org');
        return response.text();
    }
}
